/* eslint-disable object-shorthand */

import { mapActions, mapGetters, mapState } from 'vuex';
import { formMixin } from '@/components/forms/mixin';
import { TIME_OPTIONS } from '@/store/modules/leaderboards';

const A = { label: 'All Players', value: 'ALL' };

export default {
  props: {
    backButton: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    formMixin,
  ],
  data() {
    return {
      filter: {
        type: A,
        time: null,
      },
      typeOptions: [
        A,
      ],
      timeOptions: [
        TIME_OPTIONS.PAST_WEEK,
        TIME_OPTIONS.PAST_MONTH,
        TIME_OPTIONS.PAST_YEAR,
      ],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('leaderboards', ['selectedLeaderboard']),
    ...mapState('leaderboards', ['leaderboardsDateRange']),
    title() {
      const leaderboardName = this.selectedLeaderboard.leaderBoardName;
      if (leaderboardName === 'All Predictors') {
        return leaderboardName;
      }
      return `Top ${leaderboardName}`;
    },
  },
  watch: {
    'filter.time'(option) {
      this.setLeaderboardsDateRange(option.value);
    },
  },
  methods: {
    ...mapActions('leaderboards', ['setLeaderboardsDateRange']),
    setDefaultTimeFilter() {
      this.filter.time = Object.values(TIME_OPTIONS)
        .find(i => i.value === this.leaderboardsDateRange);
    },
  },
  created() {
    this.setDefaultTimeFilter();
  },
};



// WEBPACK FOOTER //
// ./src/components/leaderboards/leaderboards-toolbar/leaderboards-toolbar.js